import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataVehiculo from "./dataVehiculo";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";
import { gql, useQuery } from "@apollo/client";
import { resolveDeclaracionTemplate } from "utils/declaracionTemplate";

const FinalPdf = ({ declaracion }) => {
  const { columns, getRows } = dataVehiculo;

  const dataPeriodos = [
    {
      desde: declaracion?.inicio,
      hasta: declaracion?.fin,
      observaciones: declaracion?.anio,
    },
  ];

  const memoizedRows = useMemo(() => {
    if (dataPeriodos) {
      return getRows(dataPeriodos);
    }
    return [];
  }, [dataPeriodos]);

  const { data } = useQuery(
    gql`
      query getDatos {
        datos {
          __typename @skip(if: true)
          texto
        }
      }
    `,
    {
      fetchPolicy: "no-cache",
    }
  );

  const textoDeclaracion = useMemo(
    () => resolveDeclaracionTemplate(data?.datos?.texto, declaracion),
    [data?.datos?.texto, declaracion]
  );

  return (
    <Grid container p={2}>
      <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="flex-end">
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          RESIDUOS GENERADOS/OPERADOS/TRANSPORTADOS CORRESPONDEN AL PERÍODO
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {dataPeriodos?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay vehículos cargados" />
        )}
      </Grid>
      <Grid item xs={12} mt={4}>
        <SoftTypography
          variant="body2"
          color="black"
          sx={{
            lineHeight: 1.5,
            whiteSpace: "pre-line",
          }}
        >
          {textoDeclaracion}
        </SoftTypography>
        <SoftTypography
          variant="body2"
          color="black"
          sx={{
            lineHeight: 1.5,
          }}
        >
          Saludos Cordiales.
        </SoftTypography>
      </Grid>
      <Firma marginTop={10} ultimo />
    </Grid>
  );
};

export default memo(FinalPdf);

FinalPdf.propTypes = {
  declaracion: PropTypes.object,
};
